import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { TagModel } from '../../models/tag/tag.model';
import { tagCreated, tagDeleted, tagUpdated } from './tags.actions';

export interface TagsState extends EntityState<TagModel> {}

export const tagsAdapter: EntityAdapter<TagModel> = createEntityAdapter<TagModel>();

const initialState: TagsState = tagsAdapter.getInitialState();

export const tagsReducer = createReducer(
  initialState,
  // ADD (one or many)
  on(tagCreated, (state, tag): TagsState => {
    return tagsAdapter.addOne(tag, state);
  }),
  on(tagUpdated, (state, tag): TagsState => {
    return tagsAdapter.upsertOne(tag, state);
  }),
  // DELETE (one or many)
  on(tagDeleted, (state, { payload }): TagsState => {
    if (Array.isArray(payload)) {
      return tagsAdapter.removeMany(
        payload.map((t) => t.id),
        state,
      );
    }
    return tagsAdapter.removeOne(payload.id, state);
  }),
);
